
import { accommodationMapping } from '../mappings/AccommodationMapping';

export const applyAccommodationFilter = (dbQuery: any, accommodationType: string) => {
  const accommodationKeywords = accommodationMapping[accommodationType as keyof typeof accommodationMapping];
  const accommodationConditions = accommodationKeywords.map(keyword => 
    `typeAccommodatie.ilike.%${keyword}%,name.ilike.%${keyword}%,description.ilike.%${keyword}%`
  ).join(',');
  
  console.log('Applying accommodation type filter:', accommodationType);
  return dbQuery.or(accommodationConditions);
};
